import { environment } from '@env/environment';

export const resolveOAuthClientId = (host: Office.HostType | null): string => {
  if (typeof Office !== 'undefined') {
    switch (host) {
      case Office.HostType.Outlook:
        return environment.oauth.clientIds.outlook;
      case Office.HostType.Word:
        return environment.oauth.clientIds.word;
      case Office.HostType.Excel:
        return environment.oauth.clientIds.excel;
    }
  }

  return environment.oauth.clientIds.widget;
};
